/*                                     */
/**
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "@gr-common/head/namespaces";
import { asExport } from "@gr-exports/head/core";
import { noop } from "@gr-common/head/function";
/**
 *
 */
export const debugSync = /*           */ asExport(o_global, "debug", {});
/**
 *
 */
export const logger = /*           */ asExport(debugSync, "logger", noop);
/**
 *
 */
export const scope = /*           */ asExport(debugSync, "scope", noop);
/**
 *
 */
export const Level = /*           */ asExport(debugSync, "Level", noop);
/**
 *
 */
export const status = /*           */ asExport(debugSync, "status", noop);
